import ResourcesPage from './resources.js'
import SpecificResourcePage from './resourcepages.js'
import {useState, useEffect} from 'react'
import { firestore } from '../firebase.js';
import { collection, getDocs } from 'firebase/firestore';
import {Route, Routes} from 'react-router-dom';

function ResourceTab (props) {
    const [resources, setResources] = useState([]);
    const fetchData = async () => {
      const resourcesRef = collection(firestore, "diffTimeResources");
      const resourcesSnapshot = await getDocs(resourcesRef);
      setResources(resourcesSnapshot.docs.map((doc) => ({id: doc.id, ...doc.data()})));
    }
    
    useEffect(() => {
      fetchData();
    }, []);

    return (
        <Routes>
            <Route path="resources" element={<ResourcesPage resources={resources} type={props.type} search={props.search} setSearch={props.setSearch} setType={props.setType} time={props.time} setTime={props.setTime} day={props.day} setDay={props.setDay}/>} />
            {resources.map((location) => <Route key={location.id} path={location.name} element={<SpecificResourcePage resource={location} />}/>)}
        </Routes>
    )
}

export default ResourceTab